export const excludingId = (actions, excluding) => Object.keys(actions).reduce((all, actionId) => {
  if (Number(actionId) !== excluding) all[actionId] = actions[actionId];
  return all;
}, {});
